export const BASE_URL = 'https://core.baetorra.com';
// export const BASE_URL = 'http://localhost:8055';
export const HELP_EMAIL = 'info@baetorra.com';
export const ASSETS_URL = 'https://core.baetorra.com/assets/';
export const LOGO_URL = '/logo.jpg';
export const SPLASH_IMAGES = [
  'https://ik.imagekit.io/virtualresults/wp-sites/tr:di-noimage.png,f-auto,pr-true,fo-auto/app%2Fuploads%2Fsites%2Flei%2F2023%2F04%2Fm1.jpg',
  'https://www.tourismesardaigne.fr/wp-content/uploads/2022/07/porto-cervo-smeralda-1536x864.jpg',
];
